type User = {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
};

export function getUserLabel(user: User): string {
  return (
    [user.first_name, user.last_name].filter((part) => part).join(' ') ||
    user.email ||
    ''
  );
}
